import { Route, Routes as RouterRoutes } from 'react-router';

import { CompanyContainer } from './company_container';
import { CompanyListContainer } from './company_list_container';
import { Routes } from '../../routes';

export const CompaniesContainer = () => (
  <RouterRoutes>
    <Route path={Routes.Company.relativePath} element={<CompanyContainer />} />
    <Route index element={<CompanyListContainer />} />
  </RouterRoutes>
);
